<app-breadcrumb currentPage="Home"></app-breadcrumb>
<section class="home-hero">
  <div class="hero-decoration line-left"></div>
  <div class="hero-decoration line-right"></div>
  <div class="hero-dot dot-one"></div>
  <div class="hero-dot dot-two"></div>

  <div class="container hero-content">
    <div class="hero-copy">
      <span class="badge-label">DIGITAL SOLUTIONS • DEVELOPMENT • SUPPORT INNOVATION</span>
      <h2>Build With Confidence. Run With Peace of Mind.</h2>
      <p>We design, develop, deploy, and maintain reliable digital solutions that help businesses operate, scale, and
        grow. From modern websites and custom applications to SaaS platforms and ongoing technical support, we provide a
        complete technology partnership backed by transparent service agreements and long-term support.</p>
      <div class="service-list">
        <span>Web Development</span>
        <span>Software Development</span>
        <span>SaaS Solutions</span>
        <span>Application Maintenance</span>
        <span>Technical Support</span>
      </div>
      <div class="hero-actions">
        <a routerLink="/contactus" class="btn-primary-red"><i class="bi bi-arrow-right me-2"></i>Request for Quote</a>
        <a routerLink="/services" class="btn-outline-light">View Services</a>
      </div>
    </div>

    <div class="hero-image-wrap">
      <img src="assets/img/about/home_banner.jpg" alt="Digital technology workspace">
      <div class="hero-stats">
        <div><strong>Web Solutions</strong><span>Design & Development</span></div>
        <div><strong>Software & Product Engineerings</strong><span>Applications & Platforms</span></div>
        <div><strong>Support & Maintenance</strong><span>Ongoing Technical Support</span></div>
      </div>
    </div>
    <div class="service-list">
      <span>Clear Agreements</span>
      <span>Reliable Delivery</span>
      <span>Ongoing Support</span>
      <span>Continuous Improvement</span>
    </div>
  </div>
</section>

<section class="intro-section">
  <div class="container">
    <div class="section-heading">
      <span>WHAT WE DO</span>
      <h2>Digital Solutions Built Around Your Business</h2>
      <p>From a new idea to an existing application that needs ongoing support, SPLEX INNOVATION helps businesses
        design, develop, improve, and maintain reliable digital solutions.</p>
    </div>

    <div class="service-grid">
      @for (service of services; track service.title) {
      <article class="service-card">
        <div class="icon-box"><i class="bi" [class]="service.icon"></i></div>
        <h3>{{ service.title }}</h3>
        <p>{{ service.text }}</p>
        <a routerLink="/services">Learn more <i class="bi bi-arrow-right"></i></a>
      </article>
      }
    </div>
  </div>
</section>

<section class="home-about">
  <div class="container about-grid">
    <div class="about-image">
      <img src="assets/img/about/whysplexinov.jpg" alt="SPLEX Innovation team working on digital solutions"
        loading="lazy">
      <div class="experience-card"><strong>Build</strong><span>Innovate • Grow</span></div>
    </div>
    <div class="about-copy">
      <span class="eyebrow">WHY SPLEX INNOVATION</span>
      <h2>A Technology Partner Beyond Development</h2>
      <p>We don't just build your solution and hand it over. We work with you throughout the technology lifecycle — from
        planning and development to deployment, maintenance, improvements, and ongoing support.
      </p>
      <ul>
        <li><i class="bi bi-check2-circle"></i> Clear & Transparent Engagement</li>
        <p>Clearly defined scope, deliverables, responsibilities, and service agreements.</p>
        <li><i class="bi bi-check2-circle"></i> Business-Focused Solutions</li>
        <p>Technology designed around your actual business processes, customers, and goals.</p>
        <li><i class="bi bi-check2-circle"></i> Reliable Delivery</li>
        <p>Structured development practices focused on quality, maintainability, and predictable delivery.</p>
        <li><i class="bi bi-check2-circle"></i> Long-Term Support</li>
        <p>Continued technical assistance, maintenance, enhancements, and improvements after launch.</p>
      </ul>
      <a routerLink="/aboutus" class="text-link">Discover SPLEX Innovation <i class="bi bi-arrow-right"></i></a>
    </div>
  </div>
</section>

<section class="cta-section">
  <div class="container cta-inner">
    <div><span class="eyebrow">Let's Build Something That Works for Your Business.</span>
      <p>Whether you're starting a new digital project, improving an existing application, or looking for a reliable
        technology partner for ongoing support, let's discuss your requirements.</p>
    </div>
    <a routerLink="/contactus" class="btn-primary-red">Get Started<i class="bi bi-arrow-right ms-2"></i></a>
  </div>
</section>